import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

/**
 * Interfață bilingvă cu româna implicită (NFR-USA-001). Textele nu se codifică
 * în componente, ci trec prin chei de traducere, ca adăugarea unei limbi noi
 * să nu ceară modificarea codului (NFR-USA-004).
 */
const ro = {
  common: {
    appName: 'CIPRAL',
    save: 'Salvează', cancel: 'Renunță', search: 'Caută', export: 'Export',
    loading: 'Se încarcă…', workPoint: 'Punct de lucru', language: 'Limbă',
    profile: 'Profil', logout: 'Deconectare', logoutAll: 'Deconectare de pe toate dispozitivele',
    approvals: 'Aprobări', notifications: 'Notificări', theme: 'Temă',
    inDevelopment: 'În construcție',
    phase2: 'Faza 2', phase3: 'Faza 3',
  },
  login: {
    title: 'Autentificare',
    subtitle: 'Sistem de gestiune a producției și a operațiunilor',
    user: 'Utilizator sau email',
    password: 'Parolă',
    submit: 'Intră în cont',
    failed: 'Date de autentificare incorecte.',
    locked: 'Cont blocat temporar.',
  },
  screen: {
    notImplemented: 'Acest ecran nu este încă implementat.',
    plannedFor: 'Planificat pentru {{phase}}.',
    covers: 'Acoperă cerințele',
  },
}

const en: typeof ro = {
  common: {
    appName: 'CIPRAL',
    save: 'Save', cancel: 'Cancel', search: 'Search', export: 'Export',
    loading: 'Loading…', workPoint: 'Work point', language: 'Language',
    profile: 'Profile', logout: 'Sign out', logoutAll: 'Sign out of all devices',
    approvals: 'Approvals', notifications: 'Notifications', theme: 'Theme',
    inDevelopment: 'Under construction',
    phase2: 'Phase 2', phase3: 'Phase 3',
  },
  login: {
    title: 'Sign in',
    subtitle: 'Production and operations management system',
    user: 'Username or email',
    password: 'Password',
    submit: 'Sign in',
    failed: 'Incorrect credentials.',
    locked: 'Account temporarily locked.',
  },
  screen: {
    notImplemented: 'This screen is not implemented yet.',
    plannedFor: 'Planned for {{phase}}.',
    covers: 'Covers requirements',
  },
}

void i18n.use(initReactI18next).init({
  resources: { ro: { translation: ro }, en: { translation: en } },
  lng: 'ro',
  fallbackLng: 'ro',
  interpolation: { escapeValue: false },
})

export default i18n
